import React from 'react';
import Payments from './payments';
import ReturnRefunds from './return-refunds';
import Services from './services';
import './index.less';
import QualityCoverage from '@/component/module_ta-plus/quality-coverage';
import TaSemi from '@/component/module_ta-semi';
import { resetImage } from '@/common/reset-image';
import MyLazyComponent from '@/common/lazy-load';
import PageStore from '@/stores/page';

export default function ProductTaPlus(props: any) {
  const { seller, i18n, product, visitCountry, trade } = props;
  if (!seller) return null;
  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;
  const Shipping = MyLazyComponent(() => import('./shipping'));

  // 半托管支持
  if (trade?.taAssurances?.action) return <TaSemi {...trade.taAssurances} quickShow={true} />;

  const { protectionWithText, baoAccountIsDisplayAssurance, taIcon } = seller;
  if (!baoAccountIsDisplayAssurance) return null;
  return (
    <div className="product-ta-plus">
      <div className="product-ta-plus-title">
        <span className="product-ta-plus-title-left">{i18n['detail_ta_purchasedetails']}</span>
        <div className="product-ta-plus-title-right">
          <span className="lable">{protectionWithText}</span>
          <a href="//tradeassurance.alibaba.com/?tracelog=pdetail">
            <img src={resetImage(taIcon, '150')} />
          </a>
        </div>
      </div>
      <div>
        {isLoaded && <Shipping {...props} />}
        <Payments {...props} />
        <ReturnRefunds {...props} />
        <Services {...props} />
        <QualityCoverage {...props} />
      </div>
    </div>
  );
}
